module.exports = __webpack_public_path__ + "prod/1.2.3/img/buy_failed.59a15c4b.svg";